export function rewardsEnabledFor(environment, hostname) {
    const local = ["localhost", "127.0.0.1", "[::1]"].includes(hostname);
    if (local) return environment.REACT_APP_REWARDS_DEV_ENABLED === "1";
    return environment.REACT_APP_REWARDS_ENABLED === "1" &&
        environment.REACT_APP_REWARDS_PRODUCTION_ACTIVATION === "enabled";
}

export function rewardsEnabled() {
    return rewardsEnabledFor(process.env, window.location.hostname);
}

export function rewardsOwner(user) {
    return ["owner", "admin", "administrator"].includes(String(user?.role_name || "").trim().toLowerCase());
}

export function rewardsLabel(data, language, fallback) {
    return language?.startsWith("tl") ? (data?.display_name_tl || data?.display_name || fallback) : (data?.display_name || fallback);
}
